import styled from "styled-components"
import {Label3} from "@irati/ui/src/Labels"
import {fontColor} from "@irati/ui/src/global/colors"

const EndDate = styled(Label3)`
  color: ${fontColor};
`

export default EndDate
